module.exports = __webpack_public_path__ + "media/images/site/mail-f08055c4dbc2549b435524c08f95ded9.svg";